import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    spinnerLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Aria label for search loading spinner */
            spinnerLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "InviteScrollWrapper.spinnerLabel?c=2xzqohvscs9ht", defaultMessage: "Searching" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
